import moment from 'moment';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Col, Row } from 'antd';

import { AmountField, Card, Space, TextField } from '~/components';
import { AccountBalance } from '~/types';
import { Longdash } from '~/utils';

interface Props {
  record: AccountBalance;
  dynamicBalanceKeys: string[];
}

const BalanceCard: FC<Props> = ({ record, dynamicBalanceKeys }) => {
  const { t } = useTranslation('accounts');
  const { t: td } = useTranslation();

  return (
    <Card
      title={
        <Row>
          <Col span={15}>
            <TextField label={t('account')}>
              <span>{record.accountNumber}</span>
            </TextField>
          </Col>
          <Col span={9}>
            <TextField label={t('bankingDay')}>
              <span>{moment(record.bankingDay).format('LL')}</span>
            </TextField>
          </Col>
        </Row>
      }
      expandable
    >
      <Space size={16} direction="vertical">
        {dynamicBalanceKeys.map((key) => {
          const value = (record.balances as any)?.[key];
          return (
            <TextField key={key} label={td(key)}>
              {value !== undefined ? (
                <AmountField amount={{ value, currency: record.currency }} />
              ) : (
                Longdash
              )}
            </TextField>
          );
        })}
      </Space>
    </Card>
  );
};

export default BalanceCard;
